import { REGULAR_PAYMENT } from '../constants/actionTypes'

export default (payment = [], action) => {
    switch (action.type) {
        case REGULAR_PAYMENT:
            return action.payload;
        default:
            return payment;
    }
}